@if (draftLoaded$ | async) {
  <form
    novalidate
    #motorsDescriptionAndPhotosVideoSectionForm="ngForm"
    class="motors-description-and-photos-video-section"
    >
    <tg-row>
      <tg-col lg="6" md="12">
        <tg-input-group>
          <tg-input-container
            label="YouTube video"
            showRemainingCharacters="false"
            >
            <input
              tgTextInput
              name="youtubeVideo"
              type="text"
                        [(ngModel)]="
                            draftData.descriptionAndPhotos.youTubeVideoUrl
                        "
              placeholder="Copy and paste your YouTube link here"
              [disabled]="inputDisabled"
              (input)="onInputChange($event.target.value)"
              />
            </tg-input-container>
            <button
              tgButton2
              class="motors-description-and-photos-video-section__add-button"
              (click)="onVideoButtonClick()"
              [tgLoading]="isProcessing"
              [disabled]="!draftData.descriptionAndPhotos.youTubeVideoUrl"
              >
              {{ buttonTitle }}
            </button>
          </tg-input-group>
        </tg-col>
      </tg-row>
      @if (hasError) {
        <tg-row>
          <tg-col lg="6" md="12">
            <p
              class="motors-description-and-photos-video-section__validate-fail"
              >
              Sorry, this is not a valid URL
            </p>
          </tg-col>
        </tg-row>
      }
      <tg-row>
        <tg-col lg="6" md="12">
          <span class="p-secondary-copy">
            Please ensure advertising and annotation features are disabled.
            Check out our
            <a
              class="h-link-no-visited"
              target="_blank"
              href="https://help.trademe.co.nz/hc/en-us/articles/360007264871-Video-terms-and-conditions"
              >
              terms for adding a video
            </a>
          </span>
        </tg-col>
      </tg-row>
      @if (previewYouTubeVideoUrl) {
        <tg-row
          class="motors-description-and-photos-video-section__video-preview"
          >
          <tg-col lg="6" md="12">
            <div
              class="motors-description-and-photos-video-section__video-container"
              >
              <iframe
                width="100%"
                [src]="safeYouTubeVideoUrl"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </tg-col>
        </tg-row>
      }
    </form>
  }
